import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useAuthState } from "../../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { RegExOnlyText } from "../../../../Helper/regEx/RegExOnlyText";
import { ProjectNameDDL } from "../../../../Components/CommonDDL/ProjectNameDDL";
import { StateNameDDL } from "../../../../Components/CommonDDL/StateNameDDL";
import { RegionalOfficeNameDDL } from "../../../../Components/CommonDDL/RegionalOfficeNameDDL";
import { FieldStationOfficerDDL } from "../../../../Components/CommonDDL/FieldStationOfficerDDL";
import { ProjectWiseSurveyorDistrictPopUpTableDataAPI, ProjectWiseSurveyorPostAPI } from "../../../../Helper/Redux/MasterSlice/ProjectWiseSurveyorSlice";
import { SurveyorNameDDL } from "../../../../Components/CommonDDL/SurveyorNameDDL";

export default function AddProjectWiseSurveyorModal(props) {

    const { handleShowAddModal, handleIsPost, ShowAddModal, IsSearch, IsClear, IsPost, setIsClear } = props
    const { flag, data } = ShowAddModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [gridData, setgridData] = useState([])
    const [AllCheck, setAllCheck] = useState(false)
    const [ProjectNameID, setProjectNameID] = useState({
        DDL: [],
        ID: flag == 'Update' ? data?.m_ProjectID : 0,
        Label: flag == 'Update' ? data?.projectName : "Select...",
    })
    const [StateID, setStateID] = useState({
        DDL: [],
        ID: flag == 'Update' ? data?.m_StateNameID : 0,
        Label: flag == 'Update' ? data?.stateName : "Select...",
    })
    const [RegionalOfficeID, setRegionalOfficeID] = useState({
        DDL: [],
        ID: flag == 'Update' ? data?.m_RegionalOfficeID : 0,
        Label: flag == 'Update' ? data?.regionalOffice : "Select...",
    })

    const [FieldStationOfficerID, setFieldStationOfficerID] = useState({
        DDL: [],
        ID: flag == 'Update' ? data?.m_FieldStationOfficerID : 0,
        Label: flag == 'Update' ? data?.m_FieldStationOfficer : "Select...",
    })
    const [SurveyorNameID, setSurveyorNameID] = useState({
        DDL: [],
        ID: flag == 'Update' ? data?.m_Surveyor_TableUserID : 0,
        Label: flag == 'Update' ? data?.m_Surveyor_TableUser : "Select...",
    })

    useEffect(() => {
        const Data = {
            M_StateID: StateID.ID,
            M_TableUserMasterID: UserID,
            M_ProjectID: ProjectNameID.ID,
            M_Surveyor_TableUserID: SurveyorNameID.ID,
            M_FieldStationOfficerID :FieldStationOfficerID.ID,
            Flag: "District",
            Top: '99999',
            token: token,
        }

        dispatch(ProjectWiseSurveyorDistrictPopUpTableDataAPI({ Data }))
    }, [IsSearch, IsClear, IsPost, StateID.ID, ProjectNameID.ID, SurveyorNameID.ID,FieldStationOfficerID.ID])

    const { isLoading, tableData } = useSelector(state => state.ProjectWiseSurveyorDistrictPopUpTableData)

    useEffect(() => {
        let roleData = tableData?.table.map((item) => ({ ...item, isChecked: item.isCheck == 1 ? true : false }))
        setgridData(roleData)
        // console.log(roleData)
    }, [tableData])

    const handleOnCheckClick = (e, index, check) => {
        if (gridData) {
            let tempGridData = [...gridData]
            tempGridData[index].isChecked = check
            setgridData(tempGridData)
        }
        setAllCheck(false)
    }
    const handelAssignClicked = () => {
        let allCheckData = ""
        gridData.forEach((item) => {
            if (item.isChecked) {
                allCheckData = allCheckData + item.m_DistrictNameID + ","
            }

        })
        const data = {
            M_ProjectID: ProjectNameID.ID,
            M_StateID: StateID.ID,
            M_RegionalOfficeID: RegionalOfficeID.ID,
            M_FieldStationOfficerID: FieldStationOfficerID.ID,
            M_Surveyor_TableUserID: SurveyorNameID.ID,
            M_DistrictID: allCheckData,
            M_TableUserMasterID: UserID,
            Flag: flag,
            token: token,
            handleIsPost
        }
        dispatch(ProjectWiseSurveyorPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.ProjectWiseSurveyorPostData)

    const handleClear = () => {
        setProjectNameID({
            ...ProjectNameID,
            ID: 0,
            Label: "Select...",
        })
        setStateID({
            ...StateID,
            ID: 0,
            Label: "Select...",
        })
        setRegionalOfficeID({
            ...RegionalOfficeID,
            ID: 0,
            Label: "Select...",
        })
        setFieldStationOfficerID({
            ...FieldStationOfficerID,
            ID: 0,
            Label: "Select...",
        })
        setSurveyorNameID({
            ...SurveyorNameID,
            ID: 0,
            Label: "Select...",
        })

        setIsClear(!IsClear)
    }

    const handleClearCancel = () => {
        flag == 'Update' ? handleShowAddModal(false, '') : handleClear()
    }

    const handleAllChange = (e) => {
        gridData && gridData.map((i, index) => {
            let tempGridData = [...gridData]
            tempGridData[index].isChecked = e.target.checked
            setgridData(tempGridData)
        })
        setAllCheck(!AllCheck)
        // console.log(e)
    }


    return (
        <>
            <div
                className="modal fade show"
                style={{ display: "block", backgroundColor: "#00000055" }}
            >

                <div className="modal-dialog modal-lg modal-dialog-centered" role="document" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title ml-4" id="exampleModalLongTitle">
                                Project Wise Surveyor
                            </h5>
                            <button
                                onClick={() => handleShowAddModal(false, '')}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-4">
                            <div className="row">
                                <div className="col-12 col-xl-6 col-lg-6">
                                    <ProjectNameDDL
                                        ProjectNameID={ProjectNameID}
                                        setProjectNameID={setProjectNameID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        AstricSignFlag="AstricSign"

                                    />
                                </div>
                                <div className="col-12 col-xl-6 col-lg-6">
                                    <StateNameDDL
                                        StateID={StateID}
                                        setStateID={setStateID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        AstricSignFlag="AstricSign"
                                    />
                                </div>
                                <div className="col-12 col-xl-6 col-lg-6">
                                    <RegionalOfficeNameDDL
                                        RegionalOfficeID={RegionalOfficeID}
                                        setRegionalOfficeID={setRegionalOfficeID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        StateID={StateID}
                                        AstricSignFlag="AstricSign"
                                    />
                                </div>
                                <div className="col-12 col-xl-6 col-lg-6">
                                    <FieldStationOfficerDDL
                                        FieldStationOfficerID={FieldStationOfficerID}
                                        setFieldStationOfficerID={setFieldStationOfficerID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        RegionalOfficeID={RegionalOfficeID}
                                        AstricSignFlag="AstricSign"
                                    />
                                </div>
                                <div className="col-12 col-xl-6 col-lg-6">
                                    <SurveyorNameDDL
                                        SurveyorNameID={SurveyorNameID}
                                        setSurveyorNameID={setSurveyorNameID}
                                        apiFlag='Master'
                                        Flag={flag}
                                        data={data}
                                        IsPost=''
                                        AstricSignFlag="AstricSign"
                                    />
                                </div>

                                <div className="table-responsive p-0 pt-3 pt-lg-0" style={{ height: "35vh" }} >
                                    <table className="table table-bordered ">
                                        <thead>
                                            <tr className="bg-gradient-dark text-white">
                                                <th className=" w-6 v_sr_width">
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        value=""
                                                        id="DistrictAllCheck"
                                                        checked={AllCheck}
                                                        onChange={(e) => handleAllChange(e)}
                                                    />
                                                </th>
                                                <th className=" ps-2"> District Name </th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                gridData && gridData.length > 0 ? gridData.map((item, i) => {
                                                    return (
                                                        <>
                                                            <tr>
                                                                <td align="center">
                                                                    <input
                                                                        class="form-check-input"
                                                                        type="checkbox"
                                                                        name={item.paramName}
                                                                        value={item.paramID}
                                                                        checked={item.isChecked}
                                                                        onChange={(e) => {
                                                                            handleOnCheckClick(e, i, !item.isChecked)
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td>{item.districtName ? item.districtName : '-'}</td>

                                                            </tr>
                                                        </>
                                                    )
                                                })
                                                    :
                                                    <tr>No data found</tr>
                                            }
                                        </tbody>
                                    </table>

                                </div>

                                <div className="col-12">
                                    <div className="form-group float-end mt-lg-3">

                                        <button type="button" className="btn btn-outline-dark border-2 mx-2"
                                            disabled={ProjectNameID.ID == 0 || StateID.ID == 0 || RegionalOfficeID == 0 ||
                                                FieldStationOfficerID.ID == 0 || SurveyorNameID.ID == 0}
                                            onClick={handelAssignClicked}> {flag == 'Update' ? "Update" : "Add"}</button>

                                        <button type="button" className="btn btn-danger border-2"
                                            onClick={handleClearCancel}>
                                            {flag == 'Update' ? "Cancel" : "Clear"}
                                        </button>



                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
